import { Close } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";
import { FC, useContext } from "react";
import { UnsavedPageWarningContext } from "../../contexts/UnsavedPageWarningContext";
import ScribeFormToggle from "../../pages/health/encounters/components/ScribeFormToggle";
import { useConfirm } from "material-ui-confirm";

interface FormHeaderInterface {
  title: string;
  disableActions?: boolean;
  onClose: () => void;
}

const FormHeader: FC<FormHeaderInterface> = ({
  title,
  disableActions,
  onClose,
}) => {
  const confirm = useConfirm();
  const { isUnsavedMemory } = useContext(UnsavedPageWarningContext);

  const handleClose = async () => {
    // Block close while dictation is recording (useSaved / onClose does not cover this).
    const recordingKeys = Array.from(isUnsavedMemory.keys()).filter((key) =>
      key.startsWith("dictation-"),
    );
    const isRecording = recordingKeys.some(
      (key) => isUnsavedMemory.get(key) === true,
    );

    if (isRecording) {
      try {
        await confirm({
          title: "Recording in progress",
          description:
            "You are currently recording audio. Please stop recording before closing.",
          confirmationText: "OK",
          hideCancelButton: true,
        });
      } catch {
        // User dismissed dialog, don't close
      }
      return;
    }

    // Unsaved "discard and close?" is handled by onClose (e.g. useSaved.requestClose) to avoid double dialogs.
    onClose();
  };

  return (
    <Grid container justifyContent="space-between">
      <Grid item>
        <Typography color="primary" variant="h5">
          {title}
        </Typography>
      </Grid>
      <Grid item display="flex" alignItems="center" gap={1}>
        <ScribeFormToggle />
        <Button
          disabled={disableActions ?? false}
          endIcon={<Close />}
          variant="text"
          onClick={handleClose}
        >
          Close
        </Button>
      </Grid>
    </Grid>
  );
};

export default FormHeader;
